module.exports = __webpack_public_path__ + "ccc058eb2c37d0e181d25aaf5788c067.png";